import moment from "moment";
import { normalizeTimeFilterValue } from "utils/use-persistents-filters";

export default function getAllPersistentFilterByReq(fieldsConfig, location, navigate, formRef) {

    const urlParams = new URLSearchParams(location.search);
    // // 1. Lê os filtros da config
    const filters = {};
    fieldsConfig.forEach(field => {
        const value = readFilter(field, urlParams);
        if (value != null && (!Array.isArray(value) || value.length > 0)) {
            filters[field.field] = value;
        }
        return filters;
    });

    let filtersClean = cleanFiltersIsNull(filters);
    filtersClean = checkIfHasDateToOneField(filtersClean, true);

    //
    if (formRef.current) {
        // Campos do tipo Tempo precisam de moment no TimePicker; na query
        // permanecem como string "HH:mm"
        const formValues = { ...filtersClean };
        fieldsConfig.forEach(field => {
            if (field.type === 'time' && formValues[field.field]) {
                const parsed = moment(formValues[field.field], 'HH:mm', true);
                if (parsed.isValid()) formValues[field.field] = parsed;
            }
        });
        formRef.current.setFieldsValue(formValues);
    }

    setUrlParams(fieldsConfig, location, filtersClean, navigate);
    return filtersClean;
}

function readFilter(fieldConfig, urlParams) {

    let rawValue;

    if (fieldConfig.type === 'dateRange') {
        const start = urlParams.get(fieldConfig.queryParamStart) ?? localStorage.getItem(fieldConfig.localKeyStart);
        const end = urlParams.get(fieldConfig.queryParamEnd) ?? localStorage.getItem(fieldConfig.localKeyEnd);
        if (start || end) {
            return [
                start ? moment(start) : null,
                end ? moment(end) : null,
            ];
        }
        // fallback vírgula
        rawValue = urlParams.get(fieldConfig.queryParam) ?? localStorage.getItem(fieldConfig.localKey);
        if (rawValue) {
            const [s, e] = rawValue.split(',');
            return [
                s ? moment(Number(s) || s) : null,
                e ? moment(Number(e) || e) : null,
            ];
        }
        return [null, null];
    }

    // 2. Pega valor
    rawValue = urlParams.get(fieldConfig.queryParam) ?? localStorage.getItem(fieldConfig.localKey);
    if (!rawValue) return fieldConfig.type === 'array' ? [] : null;

    // 3. Se for array → split e retorna array
    if (fieldConfig.type === 'array') {
        return rawValue
            .split(',')
            .map(s => s.trim())
            .filter(Boolean);
    }

    // 4. Campo do tipo Tempo → normaliza para "HH:mm" (converte timestamp
    // em ms legado persistido antes da correção)
    if (fieldConfig.type === 'time') {
        return normalizeTimeFilterValue(rawValue);
    }

    // 5. Outros: text, number, etc.
    return rawValue;

}

function cleanFiltersIsNull(values) {
    const cleaned = {};

    Object.entries(values).forEach(([key, value]) => {
        if (value === undefined || value === null) return;
        if (typeof value === 'string' && value.trim() === '') return;
        if (Array.isArray(value) && value.every(v => v === null || v === undefined || v === '')) return;
        cleaned[key] = value;
    });

    return cleaned;
}

function convertReadableDateString(str) {
    const date = new Date(str);

    if (!isNaN(date.getTime())) {
        return date.getTime();
    }

    return str;
}

function checkIfHasDateToOneField(obj, isMoment) {
    Object.keys(obj).forEach(key => {
        const value = obj[key];
        if (typeof value === 'string' && value.includes(',')) {
            const [startStr, endStr] = value.split(',').map(s => convertReadableDateString(s));

            let start = Number(startStr);
            let end = Number(endStr);
            if (isMoment) {
                start = moment(Number(startStr));
                end = moment(Number(endStr));
            }
            obj[key] = [start, end];
        }
    });

    return obj;
}

function setUrlParams(fieldConfig, location, filtersClean, navigate) {
    const urlParamsToSync = new URLSearchParams();

    fieldConfig.forEach((field) => {
        const value = filtersClean[field.field];

        if (value === undefined || value === null || value === '') return;

        if (field.type === 'dateRange') {
            const [start, end] = Array.isArray(value) ? value : [value.start, value.end];
            if (start) {
                urlParamsToSync.set(field.queryParamStart, start.format('YYYY-MM-DD'));
            }
            if (end) {
                urlParamsToSync.set(field.queryParamEnd, end.format('YYYY-MM-DD'));
            }

        } else if (Array.isArray(value)) {
            if (value.length > 0) {
                urlParamsToSync.set(field.queryParam, value.join(','));
            }

        } else if (typeof value === 'string' && value.trim() !== '') {
            urlParamsToSync.set(field.queryParam, value.trim());

        } else if (value !== undefined) {
            urlParamsToSync.set(field.queryParam, String(value));
        }
    });

    const currentUrlParams = new URLSearchParams(location.search);
    const id = currentUrlParams.get('id');
    if (id) {
        urlParamsToSync.set('id', id);
    }

    const newSearch = urlParamsToSync.toString();
    const currentSearch = location.search.startsWith('?') ? location.search.slice(1) : location.search;
    if (newSearch !== currentSearch) {
        navigate({ pathname: location.pathname, search: newSearch ? `?${newSearch}` : '' }, { replace: true });
    }
}

